var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCheck02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.7489 10.4167V5.66675C16.7489 4.26662 16.7489 3.56655 16.4764 3.03177C16.2367 2.56137 15.8542 2.17892 15.3838 1.93923C14.8491 1.66675 14.149 1.66675 12.7489 1.66675H7.41553C6.0154 1.66675 5.31533 1.66675 4.78055 1.93923C4.31015 2.17892 3.92769 2.56137 3.68801 3.03177C3.41553 3.56655 3.41553 4.26662 3.41553 5.66675V14.3334C3.41553 15.7335 3.41553 16.4336 3.68801 16.9684C3.92769 17.4388 4.31015 17.8212 4.78055 18.0609C5.31533 18.3334 6.0154 18.3334 7.41553 18.3334H10.0822M11.7489 9.16675H6.74886M8.41553 12.5001H6.74886M13.4155 5.83341H6.74886M12.1655 15.8334L13.8322 17.5001L17.5822 13.7501",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck02);
export default __webpack_public_path__ + "static/media/file-check-02.a56df1cab89676e5b4c9426dbac40103.svg";
export { ForwardRef as ReactComponent };